import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../../../routes/types';
import {
  directTreasuryFiltersQuery,
  directTreasuryAssetsQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { productMarketStatusSelector } from '../../../../../store/product/selector';
import { ProductWithMarketStatus } from '../../../../../store/product/types';
import { FeatureToggle, useUnleashFlags } from '../../../../../utils/useUnleashFlags';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const DirectTreasuryTable: React.FC<DynamicAssetTableProps> = (props) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'CustomersAssetsDetails'>>();
  const { b2bRedemptionSolicitationEnabled } = useUnleashFlags(
    FeatureToggle.RedemptionSolicitationIsEnabled
  );
  const { data: marketStatusData } = useRecoilQuery(
    productMarketStatusSelector({ product: ProductWithMarketStatus.TreasuryDirect })
  );

  const handlePressQuoteButton = (productId: number, productName: string) => {
    navigate('RedemptionSolicitation', {
      ...params,
      productId,
      productName,
      productType: 'DirectTreasury',
    });
  };

  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={directTreasuryAssetsQuery}
      filtersQuery={directTreasuryFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={6}
      mobileColumns={3}
      mobileRows={2}
      quoteButtonInfoGetter={(item) => ({
        hasQuote: false,
        customProps: !b2bRedemptionSolicitationEnabled ? { display: 'none' } : {},
        onPress: () => handlePressQuoteButton(item.productId, item.productNameNormalized),
        isDisabled: !marketStatusData?.isOpen || !item.allowWithdraw,
      })}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Ativo' },
        { key: 'productTypeNormalized', label: 'Tipo' },
        { key: 'availableQuantityNormalized', label: 'Qtd. disponível' },
        { key: 'blockedQuantityNormalized', label: 'Qtd. bloqueada' },
        { key: 'totalQuantityNormalized', label: 'Qtd. total' },
        { key: 'expirationDateNormalized', label: 'Vencimento' },
        { key: 'valueNormalized', label: 'Valor bruto' },
      ]}
    />
  );
};
